const $news = $('.js-news');

const CLOSE_SELECTOR = '.js-news-close';
const OPEN_SELECTOR = '.js-news-open';
const CONTENT_SELECTOR = '.js-news-content';
const ITEM_SELECTOR = '.js-news-item';

const SCROLL_SPACING = 15;

const news = {
  initialize() {
    if (!$news.length) {
      return;
    }

    this.createEventListeners();
    this.scrollOnLoad();
  },

  createEventListeners() {
    $news.on('click', OPEN_SELECTOR, (e) => {
      e.preventDefault();
      const $row = this.getNewsRow(e.currentTarget);
      this.openRow($row);
    });

    $news.on('click', CLOSE_SELECTOR, (e) => {
      e.preventDefault();
      const $row = this.getNewsRow(e.currentTarget);
      this.closeRow($row);
    });
  },

  scrollOnLoad() {
    const $openItems = $news.find(ITEM_SELECTOR).filter('.is-open');

    if (!$openItems.length) {
      return;
    }

    if (document.readyState === 'complete') {
      this.scrollToItem($openItems.first());
      return;
    }

    $(window).on('load', () => {
      this.scrollToItem($openItems.first());
    });
  },

  scrollToItem($item) {
    const headerHeight = $('.navbar').height();

    $('html,body').animate({
      scrollTop: $item.offset().top - headerHeight - SCROLL_SPACING,
    });
  },

  getNewsRow(targetElement) {
    return $(targetElement).parents(ITEM_SELECTOR);
  },

  openRow($row) {
    const url = $row.find(OPEN_SELECTOR).attr('href');

    this.changeURL(url);

    $.ajax({
      url,
      success: (html) => {
        this.outputContentToRow($row, html);
      },
    });
  },

  closeRow($row) {
    this.changeURL($row.find(CLOSE_SELECTOR).attr('href'));
    $row.find(CONTENT_SELECTOR).empty();
    $row.removeClass('is-open');
  },

  outputContentToRow($row, html) {
    $row.addClass('is-open');
    $row.find(CONTENT_SELECTOR).html(html);
  },

  changeURL(url) {
    if (typeof window.history === 'undefined' || typeof window.history.replaceState !== 'function') {
      return;
    }

    window.history.replaceState(null, null, url);
  },
};

export default news;
